import { render, staticRenderFns } from "./IncomeAndOutgoAgriFieldIncomeDetail.html?vue&type=template&id=2a50e2c3&scoped=true&external"
import script from "./IncomeAndOutgoAgriFieldIncomeDetail.ts?vue&type=script&lang=ts&external"
export * from "./IncomeAndOutgoAgriFieldIncomeDetail.ts?vue&type=script&lang=ts&external"
import style0 from "./IncomeAndOutgoAgriFieldIncomeDetail.css?vue&type=style&index=0&id=2a50e2c3&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a50e2c3",
  null
  
)

export default component.exports